export default __webpack_public_path__ + "static/security_w.d7653db16ccfd0368c3f6e28dccc5ac2.svg";